export default "__VITE_ASSET__BMecMrnC__"